import { Campaign, ManipulatedVariable, StepTest, Disturbance } from '../types';

export const INITIAL_CAMPAIGNS: Campaign[] = [
  {
    id: 'kfs-apc-2026',
    name: 'KFS APC Model Re-ID Campaign',
    description: 'Keyera Fort Saskatchewan Fractionation & Deethanizer multivariable predictive control re-identification step-testing campaign.',
    facility: 'Keyera Fort Saskatchewan (KFS)',
    createdAt: '2026-09-01T08:00:00Z',
    status: 'Active',
  },
  {
    id: 'rimbey-frac-2026',
    name: 'Rimbey Frac Optimization Campaign',
    description: 'Rimbey Gas Plant Fractionation step-testing campaign for energy reduction.',
    facility: 'Rimbey Gas Plant',
    createdAt: '2026-07-15T08:00:00Z',
    status: 'Planned',
  },
];

export const INITIAL_MVS: ManipulatedVariable[] = [
  // ================= DEETHANIZER (12 MVs) =================
  {
    id: 'mv-deeth-01',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-101',
    description: 'Deethanizer Total Feed Flow',
    controller: 'Deethanizer',
    processArea: 'Feed System',
    units: 'm3/h',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Model Ready',
    positiveMoves: 11,
    negativeMoves: 10,
    validMoves: 21,
    rejectedMoves: 1,
    notes: 'Primary feed throughput MV. Good linearity observed.',
    updatedAt: '2026-09-20T14:30:00Z',
  },
  {
    id: 'mv-deeth-02',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-102',
    description: 'Deethanizer Feed Preheat Temperature',
    controller: 'Deethanizer',
    processArea: 'Feed System',
    units: '°C',
    recommendedStepSize: 2.5,
    approvedStepSize: 2.0,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 7,
    validMoves: 13,
    rejectedMoves: 0,
    notes: 'Hot/cold feed balance. Stepping carefully around heating limits.',
    updatedAt: '2026-09-21T09:15:00Z',
  },
  {
    id: 'mv-deeth-03',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-104',
    description: 'Deethanizer Reflux Flow Rate',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: 'm3/h',
    recommendedStepSize: 4.0,
    approvedStepSize: 3.5,
    status: 'Waiting for Steady State',
    positiveMoves: 7,
    negativeMoves: 8,
    validMoves: 15,
    rejectedMoves: 2,
    notes: 'Crucial for C2/C3 split purity. Do not step with tower pressure.',
    updatedAt: '2026-09-22T10:00:00Z',
  },
  {
    id: 'mv-deeth-04',
    campaignId: 'kfs-apc-2026',
    tag: 'PC-105',
    description: 'Deethanizer Tower Top Pressure',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: 'kPa',
    recommendedStepSize: 25.0,
    approvedStepSize: 20.0,
    status: 'Active',
    positiveMoves: 8,
    negativeMoves: 8,
    validMoves: 16,
    rejectedMoves: 1,
    notes: 'Floating pressure optimization target.',
    updatedAt: '2026-09-21T18:20:00Z',
  },
  {
    id: 'mv-deeth-05',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-107',
    description: 'Deethanizer Reboiler Hot Oil Flow',
    controller: 'Deethanizer',
    processArea: 'Reboiler & Bottoms',
    units: 'm3/h',
    recommendedStepSize: 8.0,
    approvedStepSize: 8.0,
    status: 'Model Ready',
    positiveMoves: 12,
    negativeMoves: 11,
    validMoves: 23,
    rejectedMoves: 0,
    notes: 'Controls bottoms C2 in C3+ specification. Excellent SNR.',
    updatedAt: '2026-09-19T16:00:00Z',
  },
  {
    id: 'mv-deeth-06',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-109',
    description: 'Deethanizer Bottoms Product Draw',
    controller: 'Deethanizer',
    processArea: 'Reboiler & Bottoms',
    units: 'm3/h',
    recommendedStepSize: 6.0,
    approvedStepSize: 5.0,
    status: 'Step Complete',
    positiveMoves: 10,
    negativeMoves: 10,
    validMoves: 20,
    rejectedMoves: 1,
    notes: 'Level-coupled MV on sump bottoms.',
    updatedAt: '2026-09-18T11:40:00Z',
  },
  {
    id: 'mv-deeth-07',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-111',
    description: 'Deethanizer Overhead Distillate Draw',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: 'kkg/h',
    recommendedStepSize: 2.0,
    approvedStepSize: 2.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 6,
    validMoves: 11,
    rejectedMoves: 1,
    notes: 'Gas plant sales ethane product flow.',
    updatedAt: '2026-09-22T08:30:00Z',
  },
  {
    id: 'mv-deeth-08',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-113',
    description: 'Deethanizer Overhead Condenser Temp',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: '°C',
    recommendedStepSize: 1.5,
    approvedStepSize: 1.5,
    status: 'Not Started',
    positiveMoves: 2,
    negativeMoves: 3,
    validMoves: 5,
    rejectedMoves: 0,
    notes: 'Coupled with air cooler louvers and ambient swing.',
    updatedAt: '2026-09-17T15:10:00Z',
  },
  {
    id: 'mv-deeth-09',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-115',
    description: 'Deethanizer Tray 14 Control Temp',
    controller: 'Deethanizer',
    processArea: 'Stripping Section',
    units: '°C',
    recommendedStepSize: 1.0,
    approvedStepSize: 1.0,
    status: 'Active',
    positiveMoves: 7,
    negativeMoves: 7,
    validMoves: 14,
    rejectedMoves: 1,
    notes: 'Secondary cascade target for bottom stripping section.',
    updatedAt: '2026-09-21T13:45:00Z',
  },
  {
    id: 'mv-deeth-10',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-118',
    description: 'Deethanizer Overhead Drum Level SP',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 4,
    negativeMoves: 5,
    validMoves: 9,
    rejectedMoves: 0,
    notes: 'Surge volume manipulation for downstream ethane pipeline.',
    updatedAt: '2026-09-20T11:00:00Z',
  },
  {
    id: 'mv-deeth-11',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-120',
    description: 'Deethanizer Sump Bottoms Level SP',
    controller: 'Deethanizer',
    processArea: 'Reboiler & Bottoms',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 4,
    validMoves: 9,
    rejectedMoves: 0,
    notes: 'Direct feed buffer into Frac 1/2 distribution.',
    updatedAt: '2026-09-21T16:00:00Z',
  },
  {
    id: 'mv-deeth-12',
    campaignId: 'kfs-apc-2026',
    tag: 'PC-122',
    description: 'Deethanizer Overhead Vapor Bypass',
    controller: 'Deethanizer',
    processArea: 'Overhead & Reflux',
    units: 'kPa',
    recommendedStepSize: 15.0,
    approvedStepSize: 10.0,
    status: 'Not Started',
    positiveMoves: 1,
    negativeMoves: 2,
    validMoves: 3,
    rejectedMoves: 0,
    notes: 'High differential bypass valve.',
    updatedAt: '2026-09-16T12:00:00Z',
  },

  // ================= FRAC 1 (12 MVs) =================
  {
    id: 'mv-frac1-01',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-201',
    description: 'Frac 1 Raw Feed Charge Flow',
    controller: 'Frac 1',
    processArea: 'Feed System',
    units: 'm3/h',
    recommendedStepSize: 8.0,
    approvedStepSize: 8.0,
    status: 'Model Ready',
    positiveMoves: 11,
    negativeMoves: 12,
    validMoves: 23,
    rejectedMoves: 1,
    notes: 'Primary throughput MV for Frac 1 train.',
    updatedAt: '2026-09-20T17:00:00Z',
  },
  {
    id: 'mv-frac1-02',
    campaignId: 'kfs-apc-2026',
    tag: 'RC-202',
    description: 'Frac 1 Feed Header Distribution Ratio',
    controller: 'Frac 1',
    processArea: 'Feed System',
    units: '%',
    recommendedStepSize: 3.0,
    approvedStepSize: 3.0,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 7,
    validMoves: 13,
    rejectedMoves: 0,
    notes: 'Distribution pair with Frac 2! Do NOT test both simultaneously.',
    updatedAt: '2026-09-22T09:00:00Z',
  },
  {
    id: 'mv-frac1-03',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-204',
    description: 'Frac 1 Column Reflux Flow Rate',
    controller: 'Frac 1',
    processArea: 'Overhead & Reflux',
    units: 'm3/h',
    recommendedStepSize: 6.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 8,
    negativeMoves: 9,
    validMoves: 17,
    rejectedMoves: 1,
    notes: 'Key MV for propane HD-5 spec and propylene balance.',
    updatedAt: '2026-09-21T15:30:00Z',
  },
  {
    id: 'mv-frac1-04',
    campaignId: 'kfs-apc-2026',
    tag: 'PC-205',
    description: 'Frac 1 Column Overhead Pressure',
    controller: 'Frac 1',
    processArea: 'Overhead & Reflux',
    units: 'kPa',
    recommendedStepSize: 20.0,
    approvedStepSize: 15.0,
    status: 'Active',
    positiveMoves: 7,
    negativeMoves: 6,
    validMoves: 13,
    rejectedMoves: 1,
    notes: 'Do not adjust while stepping reflux FC-204.',
    updatedAt: '2026-09-22T07:15:00Z',
  },
  {
    id: 'mv-frac1-05',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-207',
    description: 'Frac 1 Reboiler Hot Oil Duty',
    controller: 'Frac 1',
    processArea: 'Reboiler & Bottoms',
    units: 'MW',
    recommendedStepSize: 0.5,
    approvedStepSize: 0.4,
    status: 'Active',
    positiveMoves: 9,
    negativeMoves: 8,
    validMoves: 17,
    rejectedMoves: 0,
    notes: 'Drives column boilup and bottoms C3 in C4 specification.',
    updatedAt: '2026-09-21T19:00:00Z',
  },
  {
    id: 'mv-frac1-06',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-209',
    description: 'Frac 1 Bottoms C4+ Product Draw Flow',
    controller: 'Frac 1',
    processArea: 'Reboiler & Bottoms',
    units: 'm3/h',
    recommendedStepSize: 4.0,
    approvedStepSize: 4.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 6,
    validMoves: 11,
    rejectedMoves: 0,
    notes: 'Butane feed to downstream debutanizer.',
    updatedAt: '2026-09-20T10:30:00Z',
  },
  {
    id: 'mv-frac1-07',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-211',
    description: 'Frac 1 Overhead C3 Distillate Draw',
    controller: 'Frac 1',
    processArea: 'Overhead & Reflux',
    units: 'm3/h',
    recommendedStepSize: 4.5,
    approvedStepSize: 4.0,
    status: 'Active',
    positiveMoves: 7,
    negativeMoves: 7,
    validMoves: 14,
    rejectedMoves: 0,
    notes: 'Propane bullet rundown flow.',
    updatedAt: '2026-09-21T14:00:00Z',
  },
  {
    id: 'mv-frac1-08',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-214',
    description: 'Frac 1 Condenser Outlet Temp',
    controller: 'Frac 1',
    processArea: 'Overhead & Reflux',
    units: '°C',
    recommendedStepSize: 2.0,
    approvedStepSize: 1.5,
    status: 'Not Started',
    positiveMoves: 3,
    negativeMoves: 3,
    validMoves: 6,
    rejectedMoves: 0,
    notes: 'Cooling water & louver fan control.',
    updatedAt: '2026-09-17T09:00:00Z',
  },
  {
    id: 'mv-frac1-09',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-216',
    description: 'Frac 1 Tray 22 Stripping Section Temp',
    controller: 'Frac 1',
    processArea: 'Stripping Section',
    units: '°C',
    recommendedStepSize: 1.5,
    approvedStepSize: 1.2,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 5,
    validMoves: 11,
    rejectedMoves: 0,
    notes: 'Inferential tray temperature setpoint.',
    updatedAt: '2026-09-22T08:00:00Z',
  },
  {
    id: 'mv-frac1-10',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-219',
    description: 'Frac 1 Overhead Accumulator Level SP',
    controller: 'Frac 1',
    processArea: 'Overhead & Reflux',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Waiting for Steady State',
    positiveMoves: 4,
    negativeMoves: 4,
    validMoves: 8,
    rejectedMoves: 1,
    notes: 'Reflux surge inventory management.',
    updatedAt: '2026-09-22T11:20:00Z',
  },
  {
    id: 'mv-frac1-11',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-221',
    description: 'Frac 1 Tower Bottoms Boot Level SP',
    controller: 'Frac 1',
    processArea: 'Reboiler & Bottoms',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 5,
    validMoves: 10,
    rejectedMoves: 0,
    notes: 'Reboiler circulation and sump residence time.',
    updatedAt: '2026-09-21T11:45:00Z',
  },
  {
    id: 'mv-frac1-12',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-225',
    description: 'Frac 1 Feed Preheat Exchanger Temp',
    controller: 'Frac 1',
    processArea: 'Feed Preheat Exchanger',
    units: '°C',
    recommendedStepSize: 2.0,
    approvedStepSize: 2.0,
    status: 'Not Started',
    positiveMoves: 2,
    negativeMoves: 2,
    validMoves: 4,
    rejectedMoves: 0,
    notes: 'Bottoms/feed heat integration trim.',
    updatedAt: '2026-09-18T14:15:00Z',
  },

  // ================= FRAC 2 (12 MVs) =================
  {
    id: 'mv-frac2-01',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-301',
    description: 'Frac 2 Raw Feed Charge Flow',
    controller: 'Frac 2',
    processArea: 'Feed System',
    units: 'm3/h',
    recommendedStepSize: 10.0,
    approvedStepSize: 8.0,
    status: 'Model Ready',
    positiveMoves: 12,
    negativeMoves: 11,
    validMoves: 23,
    rejectedMoves: 0,
    notes: 'Main load variable for Frac 2.',
    updatedAt: '2026-09-20T16:30:00Z',
  },
  {
    id: 'mv-frac2-02',
    campaignId: 'kfs-apc-2026',
    tag: 'RC-302',
    description: 'Frac 2 Feed Distribution Ratio',
    controller: 'Frac 2',
    processArea: 'Feed System',
    units: '%',
    recommendedStepSize: 3.0,
    approvedStepSize: 3.0,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 6,
    validMoves: 12,
    rejectedMoves: 0,
    notes: 'Distribution pair with RC-202. Keep synced with plant board.',
    updatedAt: '2026-09-22T09:15:00Z',
  },
  {
    id: 'mv-frac2-03',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-304',
    description: 'Frac 2 Column Reflux Flow Rate',
    controller: 'Frac 2',
    processArea: 'Overhead & Reflux',
    units: 'm3/h',
    recommendedStepSize: 7.0,
    approvedStepSize: 6.0,
    status: 'Active',
    positiveMoves: 9,
    negativeMoves: 9,
    validMoves: 18,
    rejectedMoves: 0,
    notes: 'Propane purity control valve.',
    updatedAt: '2026-09-21T17:45:00Z',
  },
  {
    id: 'mv-frac2-04',
    campaignId: 'kfs-apc-2026',
    tag: 'PC-305',
    description: 'Frac 2 Column Overhead Pressure',
    controller: 'Frac 2',
    processArea: 'Overhead & Reflux',
    units: 'kPa',
    recommendedStepSize: 20.0,
    approvedStepSize: 15.0,
    status: 'Active',
    positiveMoves: 8,
    negativeMoves: 7,
    validMoves: 15,
    rejectedMoves: 1,
    notes: 'Overhead condenser pressure floating envelope.',
    updatedAt: '2026-09-21T21:00:00Z',
  },
  {
    id: 'mv-frac2-05',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-307',
    description: 'Frac 2 Reboiler Hot Oil Flow Rate',
    controller: 'Frac 2',
    processArea: 'Reboiler & Bottoms',
    units: 'm3/h',
    recommendedStepSize: 10.0,
    approvedStepSize: 10.0,
    status: 'Model Ready',
    positiveMoves: 11,
    negativeMoves: 10,
    validMoves: 21,
    rejectedMoves: 0,
    notes: 'Reboiler heat input for bottoms C4 recovery.',
    updatedAt: '2026-09-20T13:20:00Z',
  },
  {
    id: 'mv-frac2-06',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-309',
    description: 'Frac 2 Bottoms Heavy Draw Rate',
    controller: 'Frac 2',
    processArea: 'Reboiler & Bottoms',
    units: 'm3/h',
    recommendedStepSize: 5.0,
    approvedStepSize: 4.5,
    status: 'Active',
    positiveMoves: 7,
    negativeMoves: 7,
    validMoves: 14,
    rejectedMoves: 1,
    notes: 'Bottoms level manipulated variable.',
    updatedAt: '2026-09-21T12:00:00Z',
  },
  {
    id: 'mv-frac2-07',
    campaignId: 'kfs-apc-2026',
    tag: 'FC-311',
    description: 'Frac 2 Overhead Distillate Rate',
    controller: 'Frac 2',
    processArea: 'Overhead & Reflux',
    units: 'm3/h',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 5,
    validMoves: 11,
    rejectedMoves: 0,
    notes: 'High purity propane product sendout.',
    updatedAt: '2026-09-21T08:00:00Z',
  },
  {
    id: 'mv-frac2-08',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-314',
    description: 'Frac 2 Aerial Cooler Outlet Temp',
    controller: 'Frac 2',
    processArea: 'Overhead & Reflux',
    units: '°C',
    recommendedStepSize: 2.0,
    approvedStepSize: 2.0,
    status: 'Not Started',
    positiveMoves: 2,
    negativeMoves: 1,
    validMoves: 3,
    rejectedMoves: 0,
    notes: 'Bay louver step response test.',
    updatedAt: '2026-09-17T16:00:00Z',
  },
  {
    id: 'mv-frac2-09',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-316',
    description: 'Frac 2 Mid-Column Control Temp',
    controller: 'Frac 2',
    processArea: 'Stripping Section',
    units: '°C',
    recommendedStepSize: 1.5,
    approvedStepSize: 1.0,
    status: 'Active',
    positiveMoves: 6,
    negativeMoves: 6,
    validMoves: 12,
    rejectedMoves: 0,
    notes: 'Fast response inferential control tray.',
    updatedAt: '2026-09-22T06:30:00Z',
  },
  {
    id: 'mv-frac2-10',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-319',
    description: 'Frac 2 Overhead Drum Level SP',
    controller: 'Frac 2',
    processArea: 'Overhead & Reflux',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 4,
    validMoves: 9,
    rejectedMoves: 0,
    notes: 'Accumulator surge control.',
    updatedAt: '2026-09-20T15:00:00Z',
  },
  {
    id: 'mv-frac2-11',
    campaignId: 'kfs-apc-2026',
    tag: 'LC-321',
    description: 'Frac 2 Reboiler Sump Level SP',
    controller: 'Frac 2',
    processArea: 'Reboiler & Bottoms',
    units: '%',
    recommendedStepSize: 5.0,
    approvedStepSize: 5.0,
    status: 'Active',
    positiveMoves: 5,
    negativeMoves: 5,
    validMoves: 10,
    rejectedMoves: 0,
    notes: 'Bottoms level residence time control.',
    updatedAt: '2026-09-21T10:00:00Z',
  },
  {
    id: 'mv-frac2-12',
    campaignId: 'kfs-apc-2026',
    tag: 'TC-325',
    description: 'Frac 2 Hot Oil Supply Header Temp SP',
    controller: 'Frac 2',
    processArea: 'Hot Oil Utility',
    units: '°C',
    recommendedStepSize: 3.0,
    approvedStepSize: 2.5,
    status: 'Not Started',
    positiveMoves: 1,
    negativeMoves: 2,
    validMoves: 3,
    rejectedMoves: 0,
    notes: 'Furnace firing and hot oil loop temp.',
    updatedAt: '2026-09-18T10:00:00Z',
  },
];

export const INITIAL_STEP_TESTS: StepTest[] = [
  {
    id: 'step-001',
    campaignId: 'kfs-apc-2026',
    mvId: 'mv-deeth-01',
    mvTag: 'FC-101',
    timestamp: '2026-09-22 08:30',
    engineer: 'J. Dhaliwal',
    operator: 'M. Thompson (Console 1)',
    direction: '+',
    stepSize: 5.0,
    baselineSp: 110.0,
    targetSp: 115.0,
    holdDuration: 270,
    steadyStateAchieved: 'Yes',
    disturbancesPresent: 'No',
    analyzerResponseObserved: 'Yes',
    dataQualityRating: 5,
    checklist: {
      heldRequiredDuration: true,
      noOperatorIntervention: true,
      noEquipmentChanges: true,
      noMajorFeedChanges: true,
      analyzerResponseObserved: true,
      stableResponseObserved: true,
    },
    status: 'PASS',
    comments: 'Smooth step response. Overhead AI-101 ethane purity leveled out after 3.8h.',
    createdAt: '2026-09-22T08:30:00Z',
  },
  {
    id: 'step-002',
    campaignId: 'kfs-apc-2026',
    mvId: 'mv-frac1-03',
    mvTag: 'FC-204',
    timestamp: '2026-09-22 10:15',
    engineer: 'J. Dhaliwal',
    operator: 'C. Henderson',
    direction: '-',
    stepSize: 5.0,
    baselineSp: 78.0,
    targetSp: 73.0,
    holdDuration: 180,
    steadyStateAchieved: 'No',
    disturbancesPresent: 'Yes',
    analyzerResponseObserved: 'No',
    dataQualityRating: 2,
    checklist: {
      heldRequiredDuration: false,
      noOperatorIntervention: false,
      noEquipmentChanges: true,
      noMajorFeedChanges: false,
      analyzerResponseObserved: false,
      stableResponseObserved: false,
    },
    status: 'FAIL',
    comments: 'Truncated early due to upstream compressor trip disturbance. Data rejected.',
    createdAt: '2026-09-22T10:15:00Z',
  },
  {
    id: 'step-003',
    campaignId: 'kfs-apc-2026',
    mvId: 'mv-frac2-05',
    mvTag: 'FC-307',
    timestamp: '2026-09-22 11:45',
    engineer: 'A. Chen',
    operator: 'M. Thompson (Console 1)',
    direction: '+',
    stepSize: 10.0,
    baselineSp: 85.0,
    targetSp: 95.0,
    holdDuration: 240,
    steadyStateAchieved: 'Yes',
    disturbancesPresent: 'No',
    analyzerResponseObserved: 'Yes',
    dataQualityRating: 4,
    checklist: {
      heldRequiredDuration: true,
      noOperatorIntervention: true,
      noEquipmentChanges: true,
      noMajorFeedChanges: true,
      analyzerResponseObserved: true,
      stableResponseObserved: true,
    },
    status: 'PASS',
    comments: 'Good step response on reboiler duty. Bottoms C3 dropped from 1.8% to 0.9%.',
    createdAt: '2026-09-22T11:45:00Z',
  },
];

export const INITIAL_DISTURBANCES: Disturbance[] = [
  {
    id: 'dist-001',
    campaignId: 'kfs-apc-2026',
    timestamp: '2026-09-22 09:40',
    category: 'Compressor changes',
    controller: 'Plant-Wide',
    description: 'Refrigeration compressor C-201 trip and restart on secondary motor. Caused brief suction pressure spike.',
    engineer: 'J. Dhaliwal',
    createdAt: '2026-09-22T09:40:00Z',
  },
  {
    id: 'dist-002',
    campaignId: 'kfs-apc-2026',
    timestamp: '2026-09-21 14:15',
    category: 'Analyzer maintenance',
    controller: 'Deethanizer',
    description: 'AI-101 overhead ethane gas chromatograph routine calibration and carrier gas cylinder swap. Off-spec flag active 45 min.',
    engineer: 'A. Chen',
    createdAt: '2026-09-21T14:15:00Z',
  },
  {
    id: 'dist-003',
    campaignId: 'kfs-apc-2026',
    timestamp: '2026-09-20 22:30',
    category: 'Weather impacts',
    controller: 'Frac 1',
    description: 'Sudden rainstorm and 12°C ambient temperature drop affected aerial condenser cooling capacity.',
    engineer: 'J. Dhaliwal',
    createdAt: '2026-09-20T22:30:00Z',
  },
];
